import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { Utils } from '../functions/utils'
import { ws } from '../functions/ws'
import { IState } from '../models/state'

interface IMatchParams {
	depositId: string
}
export const DepositDetailsMain = () => {

	const depositDetails = useSelector((state: IState) => state.depositDetails)

	const { depositId } = useParams<IMatchParams>()
	React.useEffect(
		() => {
			ws.send({ type: 'DepositDetails.Get', depositId } as any)
		},
		[])
	
	const pdfIcon = require('../images/pdf.svg')

	const tags: any = {
		unverified: 'tagPurple',
		pending: 'tagYellow',
		verified: 'tagGreen',
		blocked: 'tagRed',
		admin: 'tagBlack',
		operator: 'tagGrey',
		Confirmed: 'tagGreen',
		Unconfirmed: 'tagYellow',
		Cancelled: 'tagRed'
	}

	const approve = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'DepositDetails.Approve', depositId } as any)
		}
	}

	const cancel = () => {
		if (confirm('Are you sure?')) {
			ws.send({ type: 'DepositDetails.Cancel', depositId } as any)
		}
	}

	return (
		<div className='ordersMain'>
			<span className='pageTitle'>Deposits</span>
			<span className='pageBoxTitle'>Deposit Details</span>
			<div>
				<table className='depositsTableMain'>
					<thead>
						<tr className='depositsTableHeaderRow'>
							<td className='depositsTableHeaderRowItem idColumn'>Deposit ID</td>
							<td className='depositsTableHeaderRowItem dateColumn'>Date</td>
							<td className='depositsTableHeaderRowItem'>Coin</td>
							<td className='depositsTableHeaderRowItem'>Amount</td>
							<td className='depositsTableHeaderRowItem'>Deposit Status</td>
						</tr>
					</thead>
					<tbody>
						{depositDetails ?
							<tr className='depositsTableBodyRow'>
								<td className='depositsTableBodyRowItem'>{Utils.pad(Utils.base32.encode(depositDetails.id || 0), 6)}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.date ? new Date(depositDetails.date).toLocaleString('en-GB') : ''}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.coin}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.amount.toFixed(2)}</td>
								<td className='depositsTableBodyRowItem'><span className={`profileFormTag ${tags[depositDetails.status]}`}>{depositDetails.status}</span></td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Bank Account Details</span>
			<div>
				<table className='depositsTableMain'>
					<thead>
						<tr className='depositsTableHeaderRow'>
							<td className='depositsTableHeaderRowItem'>Bank Number</td>
							<td className='depositsTableHeaderRowItem'>Branch Number</td>
							<td className='depositsTableHeaderRowItem'>Account Number</td>
							<td className='depositsTableHeaderRowItem'>Full Name</td>
							<td className='depositsTableHeaderRowItem'>Document ID Number</td>
							<td className='depositsTableHeaderRowItem'>User Status</td>
							<td className='depositsTableHeaderRowItem'>Actions</td>
						</tr>
					</thead>
					<tbody>
						{depositDetails ?
							<tr className='depositsTableBodyRow'>
								<td className='depositsTableBodyRowItem'>{depositDetails.bankAccount.bankNumber}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.bankAccount.branchNumber}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.bankAccount.accountNumber}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.fullName}</td>
								<td className='depositsTableBodyRowItem'>{depositDetails.docIdNumber}</td>
								<td className='depositsTableBodyRowItem'><span className={`profileFormTag ${tags[depositDetails.userStatus || '']}`}>{depositDetails.userStatus}</span></td>
								<td className='depositsTableBodyRowItem'><Link className='walletsTableButton' to={`/userDetails/${depositDetails.userId}`}>View Details</Link></td>
							</tr>
							: <></>
						}
					</tbody>
				</table>
			</div>
			<br />
			<span className='pageBoxTitle'>Actions</span>
			<div className='pageColumn3Box'>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonRed'>
						<button onClick={cancel} type='submit'>Cancel</button>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='goBackButtonYellowDiv'>
						<Link className='goBackButtonYellow' to='/deposits'>Go Back</Link>
					</div>
				</div>
				<div className='pageColumn3'>
					<div className='kycSubmitButtonGreen'>
						<button onClick={approve} type='submit'>Approve</button>
					</div>
				</div>
			</div>
			<br />
			<span className='pageBoxTitle'>Uploads</span>
			<div>
				<table className='ordersTableMain'>
					<thead>
						<tr className='ordersTableHeaderRow'>
							<td className='ordersTableHeaderRowItem'>Deposit Receipt Photo</td>
						</tr>
					</thead>
					<tbody>
						<tr className='ordersTableBodyRow'>
							<td className='ordersTableBodyRowItem receiptColumn'>
								{depositDetails?.receiptPic?.startsWith('data:image')
									?
									<img src={depositDetails?.receiptPic} className='receiptUpload' alt='Deposit Receipt Photo' />
									: depositDetails?.receiptPic
										?
										<a href={depositDetails?.receiptPic} download='receipt.pdf'>
											<img src={pdfIcon} alt='deposit_receipt' />
										</a>
										:
										<div />
								}
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div >
	)
}


// WEBPACK FOOTER //
// ./src/components/depositDetailsMain.tsx